export default "__VITE_ASSET__CL6tZkBr__"